import React from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const QuestionNavigator = ({
  questions,
  status,
  currentQuestion,
  onQuestionSelect,
  onSubmit,
  syncStatus,
  allowBackNavigation = false
}) => {




  const getStatusClass = (statusValue) => {
    if (!statusValue || statusValue.trim() === "") {
      return "not-visited";
    }

    return statusValue;
  };


  const renderNavigationButton = (index, questionStatus) => {
    const statusClass = getStatusClass(questionStatus);
    const sync = syncStatus?.[questions[index]?.questionId];
    // let extraClass = "";
    let extraClass = "";

    // if (sync === "local") {
    //     extraClass += " local-sync";
    // }

    // if (sync === "mongo") {
    //     extraClass += " mongo-sync";
    // }

    const isAnswered =
      questionStatus === "answered" ||
      questionStatus === "answered-marked";

    if (isAnswered && sync === "local") {
      extraClass += " local-sync";
    }

    if (isAnswered && sync === "mongo") {
      extraClass += " mongo-sync";
    }
    // const isPreviousQuestion = index < currentQuestion;
    // const isDisabled = isPreviousQuestion && !allowBackNavigation;
    const isNavigatorFrozen = !allowBackNavigation;

    // if (index === currentQuestion) {
    //   extraClass = "active blink";
    // }
    if (index === currentQuestion) {
      extraClass += " active blink";
    }

    return (
      // <button
      //   key={index}
      //   className={`nav-btn ${statusClass} ${extraClass}`}
      //   onClick={() => {
      //     if (!isDisabled) onQuestionSelect(index);
      //   }}
      //   disabled={isDisabled}
      //   title={isDisabled ? "Back navigation is not allowed" : undefined}
      // >
      <button
  key={index}
  className={`nav-btn ${statusClass} ${extraClass} ${
    isNavigatorFrozen ? "navigator-view-mode" : ""
  }`}
  onClick={() => {
    if (!isNavigatorFrozen) {
      onQuestionSelect(index);
    }
  }}
  disabled={isNavigatorFrozen}
  title={
    isNavigatorFrozen
      ? "Question Navigator is in View Mode"
      : undefined
  }
>
        {/* {index + 1}

      {Number(questions[index]?.is_mandatory) === 1 && (
        <span className="mandatory-star">*</span>
      )} */}

        {index + 1}

        {Number(questions[index]?.is_mandatory) === 1 && (
          <span className="mandatory-star">*</span>
        )}

        {(questionStatus === "marked" ||
          questionStatus === "answered-marked") && (
            <BookmarkIcon
              className="review-icon"
              sx={{
                fontSize: 14,
                color: "#ff9800"
              }}
            />
          )}
      </button>
    );
  };
  return (
    <div className="card">
      <h3 className="font22">Question Navigator</h3>
      <div className="navigator">
        {status.map((questionStatus, index) =>
          renderNavigationButton(index, questionStatus)
        )}
      </div>

      <button className="btn BlueBtn mock" onClick={onSubmit}>
        <i className="fa fa-check pr-1"></i> Submit Assessment
      </button>
    </div>
  );
};

export default QuestionNavigator;



